import { String, Object, Number, Optional, Static, Record, Union, Any } from '@sinclair/typebox';

export const Points = Object({
  total: Number(),
  originalTotal: Optional(Number()),
});

export type PriceItem = Static<typeof PriceItem>;
export const PriceItem = Object({
  cash: Object({
    total: Number(),
    tax: Number(),
  }),
  points: Optional(Union([Points, Any()])),
});

export type MatrixItem = Static<typeof MatrixItem>;
export const MatrixItem = Object({
  price: Record(String(), PriceItem),
  availableSeats: Number(),
});

export type AssociationMatrix = Static<typeof AssociationMatrix>;
export const AssociationMatrix = Record(String(), Record(String(), MatrixItem));

export type CalendarAssociationsMatrix = Static<typeof CalendarAssociationsMatrix>;
export const CalendarAssociationsMatrix = Record(String(), Record(String(), Number()));
